import type { DataById } from 'state/formData/formData.model';

export interface EnrichFormRequest {
  tabId?: string;
  negotiationId?: string;
  version: number;
  productType: string;
  productSubType: string;
  wrapper: string;
  variationParameters: DataById;
  rfq?: DataById;
}

export function isProductSwitch(request: EnrichFormRequest): boolean {
  return (
    request.variationParameters.ProductType !== undefined || request.variationParameters.ProductSubtype !== undefined
  );
}
